import { createContext, h } from 'preact'
import { useContext } from 'preact/hooks'
import { History } from 'history'
import { SendGaEvent } from './analytics'
import { SendError } from './error-reporting'

export type CustomContextType = {
  sendGaEvent: SendGaEvent
  sendError: SendError
  history?: History
  widgetHost?: string
}

export const CustomContext = createContext<CustomContextType>({
  sendGaEvent: () => {},
  sendError: () => {}
})

export function Provider(props: any) {
  return (
    <CustomContext.Provider value={{ ...this.props.value }}>
      {props.children}
    </CustomContext.Provider>
  )
}

export function useCustomContext() {
  return useContext(CustomContext) || ({} as any)
}
